import { driveFileIdAusUrl } from './weiterleitung';

// Sammelaktionen über mehrere Belege (Herunterladen, per Mail senden). Die Auswahl umfasst
// bewusst BEIDE Quellen — gebuchte Rechnungen und KI-Pool-Belege: bei der Belegprüfung will
// man nicht danach sortieren, ob die KI einen Beleg schon einbuchen konnte.

export interface AuswahlBeleg {
  id: string;
  rechnungsnummer?: string | null;
  unternehmen?: string | null;
  datum?: string | null;
  datei_url?: string | null;
  is_unklar_source?: boolean;
}

export interface BelegDatei {
  id: string;
  fileId: string;
  dateiname: string;
}

/** Dateiname für den Download: Nummer, sonst Firma, sonst Kennung — nie leer, nie mit Pfadzeichen. */
export function belegDateiname(b: AuswahlBeleg): string {
  const roh = (b.rechnungsnummer || '').trim()
    || (b.unternehmen || '').trim()
    || `Beleg_${String(b.id).slice(0, 8)}`;
  const sauber = roh.replace(/[^\wäöüÄÖÜß.\- ]+/g, '_').replace(/\s+/g, '_').slice(0, 80);
  return `Rechnung_${sauber}.pdf`;
}

/**
 * Zerlegt die Auswahl in herunterladbare Dateien und Belege ohne hinterlegte PDF.
 * Doppelte Dateinamen werden nummeriert (zwei Belege derselben Firma ohne Nummer).
 */
export function belegDateien(belege: AuswahlBeleg[]): { dateien: BelegDatei[]; ohneDatei: AuswahlBeleg[] } {
  const dateien: BelegDatei[] = [];
  const ohneDatei: AuswahlBeleg[] = [];
  const vergeben = new Map<string, number>();

  for (const b of belege) {
    const fileId = driveFileIdAusUrl(b.datei_url);
    if (!fileId) { ohneDatei.push(b); continue; }
    const basis = belegDateiname(b);
    const zaehler = (vergeben.get(basis) ?? 0) + 1;
    vergeben.set(basis, zaehler);
    const dateiname = zaehler === 1 ? basis : basis.replace(/\.pdf$/i, `_${zaehler}.pdf`);
    dateien.push({ id: b.id, fileId, dateiname });
  }
  return { dateien, ohneDatei };
}

/** Betreff für den Sammelversand: „3 Belege" bzw. der einzelne Beleg beim Namen. */
export function sammelBetreff(belege: AuswahlBeleg[]): string {
  if (belege.length === 1) {
    const b = belege[0];
    const nr = (b.rechnungsnummer || '').trim();
    return nr ? `Rechnung ${nr}` : 'Rechnung';
  }
  return `${belege.length} Belege`;
}

/** Trennt eine Auswahl nach Quelle — die Sammelaktionen schreiben in zwei Tabellen. */
export function teileNachQuelle<T extends AuswahlBeleg>(belege: T[]): { rechnungen: T[]; pool: T[] } {
  return {
    rechnungen: belege.filter((b) => !b.is_unklar_source),
    pool: belege.filter((b) => !!b.is_unklar_source),
  };
}
